import ProfileContext from "context/ProfileContext";
import React, { useContext, useState, useEffect, useCallback } from "react";
import { Spinner, Table } from "react-bootstrap";
import { CaretDown, CaretUp, Search } from "react-bootstrap-icons";
import HostList from "./HostList";
import "./hostlisting.css";
import { Field, Form, Formik } from "formik";
import InfiniteScroll from 'react-infinite-scroll-component';

const HostApprovals = () => {
  let {
    updatedHosts,
    updateHostRequests,
    nextStepHostApproval,
  } = useContext(ProfileContext);
  const [loadingPros, setLoadingPros] = useState(false);
  const [searchTerminology, setSearchTerminology] = useState("");
  const [sortStatus, setSortStatus] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  // Fetch more data for infinite scroll (scoped to this tab container)
  const fetchMoreData = useCallback(() => {
    if (!hasMore || loadingPros || !nextStepHostApproval) return;
    setLoadingPros(true);
    const res = updateHostRequests(new URL(nextStepHostApproval).search, true);
    res
      .then(() => {
        setLoadingPros(false);
        if (!nextStepHostApproval) {
          setHasMore(false);
        }
      })
      .catch(() => {
        setLoadingPros(false);
      });
  }, [hasMore, loadingPros, nextStepHostApproval, updateHostRequests]);

  // Reset hasMore when search or sort changes
  useEffect(() => {
    setHasMore(true);
  }, [searchTerminology, sortStatus]);

  const gethosts = () => {
    if (updatedHosts && updatedHosts.length < 1 && !loadingPros) {
      return (
        <tr>
          <td className="no-data-wrap" colSpan="7">No data available yet!</td>
        </tr>
      );
    } else {
      const uniqueHosts = [];
      const seenIds = new Set();

      updatedHosts?.forEach((updatedhost) => {
        const key = updatedhost.id;
        if (!key || !seenIds.has(key)) {
          if (key) {
            seenIds.add(key);
          }
          uniqueHosts.push(updatedhost);
        }
      });

      const hostRows = uniqueHosts.map((updatedhost, index) => {
        return <HostList key={`${updatedhost.id || index}`} hostDetails={updatedhost} />;
      });

      return hostRows;
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-end">
        <div className="search-wrapper col-md-4 col-sm-5 mb-3">
          <Formik
            initialValues={{ searchterm: "" }}
            onSubmit={(value) => {
              setLoadingPros(true);
              setHasMore(true);
              let res = updateHostRequests(
                `?order=true&search=${value.searchterm}`
              );
              res.then(() => setLoadingPros(false));
            }}
          >
            {({ setFieldValue, values }) => (
              <Form>
                <div className="row">
                  <div className="col-12 d-flex">
                    <Field
                      type="search"
                      placeholder="Search Product"
                      className="form-control"
                      onChange={(e) => {
                        setSearchTerminology(e.target.value);
                        setFieldValue("searchterm", e.target.value);
                      }}
                      value={values.searchterm}
                      name="searchterm"
                    />
                    <button type="submit" className="search magnifier">
                      <Search />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

    <div
      id="approvalsScrollableDiv"
      style={{ height: '600px', overflow: 'auto' }}
    >
    <InfiniteScroll
      dataLength={updatedHosts?.length || 0}
      next={fetchMoreData}
      hasMore={hasMore}
      loader={
        loadingPros && updatedHosts?.length > 0 && (
          <div className="d-flex justify-content-center py-3">
            <Spinner animation="grow" />
            <Spinner animation="grow" />
            <Spinner animation="grow" />
          </div>
        )
      }
      scrollableTarget="approvalsScrollableDiv"
      endMessage={
        <div className="text-center py-3 text-muted">
          {!hasMore && updatedHosts?.length > 0 && "You have seen all host approvals!"}
        </div>
      }
    >
      <Table className="table-store" responsive>
        <thead>
          <tr>
            <th scope="col">
              <div className="arrows">
                Real Customer
                <div
                  className="arrow-grid"
                  onClick={() => {
                    setLoadingPros(true);
                    setSortStatus(!sortStatus);
                    setHasMore(true);
                    let res = updateHostRequests(
                      `?order=true&host=${sortStatus}&search=${searchTerminology}`
                    );
                    res.then(() => setLoadingPros(false));
                  }}
                >
                  <CaretUp />
                  <CaretDown />
                </div>
              </div>
            </th>
            <th scope="col">
              <div className="arrows">
                Time waiting{" "}
                <div
                  className="arrow-grid"
                  onClick={() => {
                    setLoadingPros(true);
                    setSortStatus(!sortStatus);
                    setHasMore(true);
                    let res = updateHostRequests(
                      `?order=${sortStatus}&search=${searchTerminology}`
                    );
                    res.then(() => setLoadingPros(false));
                  }}
                >
                  <CaretUp />
                  <CaretDown />
                </div>
              </div>
            </th>
            <th scope="col">
              <div className="arrows">
                Responses{" "}
                <div
                  className="arrow-grid"
                  onClick={() => {
                    setLoadingPros(true);
                    setSortStatus(!sortStatus);
                    setHasMore(true);
                    let res = updateHostRequests(
                      `?order=true&order_by=responses&sort=${sortStatus}&search=${searchTerminology}`
                    );
                    res.then(() => setLoadingPros(false));
                  }}
                >
                  <CaretUp />
                  <CaretDown />
                </div>
              </div>
            </th>
            <th scope="col">
              <div className="arrows">
                Product{" "}
                <div
                  className="arrow-grid"
                  onClick={() => {
                    setLoadingPros(true);
                    setSortStatus(!sortStatus);
                    setHasMore(true);
                    let res = updateHostRequests(
                      `?order=true&order_by=product&sort=${sortStatus}&search=${searchTerminology}`
                    );
                    res.then(() => setLoadingPros(false));
                  }}
                >
                  <CaretUp />
                  <CaretDown />
                </div>
              </div>
            </th>
            <th scope="col">
              <div className="arrows">
                Edited{" "}
                <div
                  className="arrow-grid"
                  onClick={() => {
                    setLoadingPros(true);
                    setSortStatus(!sortStatus);
                    setHasMore(true);
                    let res = updateHostRequests(
                      `?order=true&edited=${sortStatus}&search=${searchTerminology}`
                    );
                    res.then(() => setLoadingPros(false));
                  }}
                >
                  <CaretUp />
                  <CaretDown />
                </div>
              </div>
            </th>
            <th>Media</th>
            <th>Social</th>
          </tr>
        </thead>
        <tbody>{gethosts()}</tbody>
      </Table>
    </InfiniteScroll>
    </div>
      
      {/* Show loading spinner for initial load */}
      {loadingPros && (!updatedHosts || updatedHosts.length === 0) && (
        <div className="d-flex justify-content-center py-4">
          <Spinner animation="grow" />
          <Spinner animation="grow" />
          <Spinner animation="grow" />
        </div>
      )}
    </div>
  );
};

export default HostApprovals;